import { render, staticRenderFns } from "./ItemListGalleryUserLayout.vue?vue&type=template&id=96e84a46&scoped=true"
import script from "./ItemListGalleryUserLayout.vue?vue&type=script&lang=js"
export * from "./ItemListGalleryUserLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e84a46",
  null
  
)

export default component.exports